/**
 * Created by shiyonggao on 2019/2/25.
 */

import axios from "axios";

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    gameCodeLang: [],
    pushTopicGroupList: [],
    pushListByLang:[],
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_GAME_CODE_LANG({state, commit, dispatch, rootState}, args){
        let push_ajax_rela_get_game_code_lang_url = rootState.$config.api.push_ajax_rela_get_game_code_lang_url;
        rootState.$helper.request.get(push_ajax_rela_get_game_code_lang_url, args)
            .then((res)=>{
                commit('_getGameCodeLang', res.data.result);
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    GET_PUSH_TOPIC_GROUP_LIST({state, commit, dispatch, rootState}, args) {


        let push_games_code_push_topic_group_url = rootState.$config.api.push_games_code_push_topic_group_url;
        push_games_code_push_topic_group_url = push_games_code_push_topic_group_url.replace('{game_code}',args.game_code);

        rootState.$helper.request.get(push_games_code_push_topic_group_url, {limit:1000,...args})
            .then((res)=>{
                commit('_setPushTopicGroupList', res.data);
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    GET_PUSH_LIST_BY_LANG({state, commit, dispatch, rootState}, args) {

        let push_push_topics_url = rootState.$config.api.push_push_topics_url;

        rootState.$helper.request.get(push_push_topics_url, {lang:args.lang,limit:1000})
            .then((res)=>{
                commit('_setPushListByLang', res.data);
                if(typeof args.callback === 'function') {
                    args.callback();
                }
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    ADD_PUSH_TOPIC_GROUP({state, commit, dispatch, rootState}, args) {
        let push_add_games_code_push_topic_group_url = rootState.$config.api.push_add_games_code_push_topic_group_url;
        push_add_games_code_push_topic_group_url = push_add_games_code_push_topic_group_url.replace('{game_code}',args.game_code);

        rootState.$helper.request.put(push_add_games_code_push_topic_group_url, args)
            .then((res)=>{
                dispatch('GET_PUSH_TOPIC_GROUP_LIST',{game_code:args.game_code,lang:args.now_lang})
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });

    },
    EDIT_PUSH_TOPIC_GROUP({state, commit, dispatch, rootState}, args) {

        let push_edit_games_code_push_topic_group_id_url = rootState.$config.api.push_edit_games_code_push_topic_group_id_url;
        push_edit_games_code_push_topic_group_id_url = push_edit_games_code_push_topic_group_id_url.replace('{game_code}',args.game_code);
        push_edit_games_code_push_topic_group_id_url = push_edit_games_code_push_topic_group_id_url.replace('{topic_group_id}',args.topic_group_id);

        rootState.$helper.request.put(push_edit_games_code_push_topic_group_id_url, args)
            .then((res)=>{
                dispatch('GET_PUSH_TOPIC_GROUP_LIST',{game_code:args.game_code,lang:args.now_lang})
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },
    ADD_PLAN_SCHEDULES({state, commit, dispatch, rootState}, args) {
        let push_add_schedules_url = rootState.$config.api.push_add_schedules_url;
        push_add_schedules_url = push_add_schedules_url.replace('{game_code}',args.game_code);

        rootState.$helper.request.put(push_add_schedules_url, args)
            .then((res)=>{
                dispatch('GET_PUSH_TOPIC_GROUP_LIST',{game_code:args.game_code,lang:args.now_lang})
            })
            .catch((res)=>{
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },
    SET_PUSH_LIST_BY_LANG({state, commit, dispatch, rootState}, args) {

        commit('_setPushListByLang', []);

    },
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {


};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _getGameCodeLang(state, args){
        state.gameCodeLang = args;
    },

    _setPushTopicGroupList(state, args) {
        state.pushTopicGroupList = args.topic_groups;

    },
    _setPushListByLang(state, args) {
        state.pushListByLang = args.topics;

    }


};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/push/PushPlanManager.js